import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import MainContainer from "layout/atoms/MainContainer";
import { fetchBoards, selectAllBoards } from "store/boardsSlice";
import { selectCompanyInfo } from "store/companySlice";
import { clearCurrentBoard } from "store/currentBoardSlice";
import { openModal } from "store/modalsSlice";

import Alert from "layout/atoms/Alert";
import Button from "layout/atoms/Button";
import GridBoardList from "layout/atoms/GridBoardList";
import Icon from "layout/atoms/Icon";
import Loader from "layout/atoms/Loader";

import BoardCard from "layout/molecules/BoardCard";
import EmptyState from "layout/molecules/EmptyState";

import { ReactComponent as plusSquare } from "assets/icons/plus-square.svg";

function BoardsList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const boards = useSelector(selectAllBoards);
  const boardStatus = useSelector((state) => state.boards.status);
  const companyInfo = useSelector(selectCompanyInfo);

  useEffect(() => {
    dispatch(clearCurrentBoard());
    if (
      companyInfo.id &&
      (boardStatus === "idle" || boardStatus === "failed")
    ) {
      dispatch(fetchBoards());
    }
  }, [boardStatus, companyInfo.id, dispatch]);

  const inactiveBoardExist = () =>
    boards.filter((board) => board.active === false).length > 0;

  const handleAddBoard = () => dispatch(openModal({ name: "addBoardModal" }));

  return (
    <MainContainer
      topbar={
        <>
          {" "}
          <div>
            <h2>{t("boardsList.title")}</h2>
          </div>
          <div>
            <Button size="lg" color="primary" onClick={handleAddBoard}>
              <Icon src={plusSquare} />
              <p>{t("boardsList.button")}</p>
            </Button>
          </div>
        </>
      }
    >
      {inactiveBoardExist() && (
        <Alert type="warning">
          <Trans i18nKey="boardsList.inactiveBoardsPopup">
            Some boards are inactive.
            <NavLink to="/admin/subscription">Upgrade your plan</NavLink>
            to activate them all.
          </Trans>
        </Alert>
      )}
      {boardStatus === "loading" ? (
        <Loader />
      ) : boards.length !== 0 ? (
        <GridBoardList>
          {boards.map((board) => (
            <BoardCard key={board.id} boardData={board} />
          ))}
        </GridBoardList>
      ) : (
        <EmptyState
          type="noBoards"
          header={t("emptyStates.boards.header")}
          subheader={t("emptyStates.boards.subheader")}
        >
          <Button color="primary" onClick={handleAddBoard}>
            {t("emptyStates.boards.button")}
          </Button>
        </EmptyState>
      )}
    </MainContainer>
  );
}

export default BoardsList;
